<div class="hw-header-wrap" >
    <div class="row">
        <div class="col" innerHTML="{{ activeMenu.name | fnTranslate  }}">

            @if (activeMenu && activeMenu.menuSmallIcon){
                <i [classList]="activeMenu.menuSmallIcon"></i>
              } @else if (activeMenu && activeMenu.smallIcon) {
                <i [classList]="activeMenu.smallIcon"></i>
              } 
        </div>
    </div>
</div>
